import React, { Suspense } from "react";
import GlobalStyles from './styles/GlobalStyles';
import { css } from "styled-components/macro"; //eslint-disable-line
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

// Layouts (loaded immediately - small bundle)
import MainLayout from "./layout/MainLayout";
import LoginLayout from "layout/LoginLayout";

// Lazy load all pages to reduce initial bundle
const Home = React.lazy(() => import("./pages/Home"));
const Signup = React.lazy(() => import("./pages/Signup"));
const Login = React.lazy(() => import("./pages/Login"));
const CategoryDetailPage = React.lazy(() => import("./pages/category/CategoryDetailPage"));
const AboutUs = React.lazy(() => import("./pages/AboutUs"));
const ContactUs = React.lazy(() => import("./pages/ContactUs"));
const SubCategoryDetailPage = React.lazy(() => import("./pages/category/SubCategoryDetailPage"));
const CartPage = React.lazy(() => import("./pages/AddToCart"));
const SuccessPage = React.lazy(() => import("./pages/success"));
const PickUp = React.lazy(() => import("pages/PickUp"));
const Checkout = React.lazy(() => import("pages/Checkout"));
const MyOrder = React.lazy(() => import("pages/MyOrder"));
const Payment = React.lazy(() => import("pages/payment"));
const Treats = React.lazy(() => import("pages/category/Treats"));
const TreatDetailsPage = React.lazy(() => import("pages/productDetails/TreatDetailsPage"));
const ProductDetailsPage = React.lazy(() => import("pages/productDetails/ProductDetailsPage"));
const Blog = React.lazy(() => import("pages/blogs/Blog"));
const BlogDetails = React.lazy(() => import("pages/blogs/BlogDetails"));
const NotFound = React.lazy(() => import("./pages/NotFound"));

// Fallback loader component
const PageLoader = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <div>Loading...</div>
  </div>
);
export default function App() {
  return (
    <>
      <GlobalStyles />
      <Router>
        <ScrollToTop />
        <FloatingWhatsApp />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route element={<LoginLayout />}>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
            </Route>
            <Route path="/" element={<MainLayout />} >
              <Route path="/" element={<Home />} />
              <Route path="/category/:categorySlug" element={<CategoryDetailPage />} />
              <Route path="/category/:categorySlug/:subCategorySlug" element={<SubCategoryDetailPage />} />
              <Route path="/category/treats" element={<Treats />} />
              <Route path="/category/treats/:productSlug" element={<TreatDetailsPage />} />
              <Route path="/category/:categorySlug/:subCategorySlug/:productSlug" element={<ProductDetailsPage />} />
              <Route path="/aboutus" element={<AboutUs />} />
              <Route path="/contactus" element={<ContactUs />} />
              <Route path="/blogs" element={<Blog />} />
              <Route path="/blogs/:blogSlug" element={<BlogDetails />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/success" element={<SuccessPage />} />
              <Route path="/pick-up" element={<PickUp />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/my-orders" element={<MyOrder />} />
              <Route path="/payment" element={<Payment />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Suspense>
      </Router>
    </>
  );
}

//#ab3d63
//#e38aba
//#e69da0
//#85b7ad